import { ICustomer } from "shared-types/SharedTypes";

export const classPrefix = 'ExistingCustomerDisplay';
export interface IBaseProps {
  customer: ICustomer
  setCustomer: (type: string, value: any) => void;
  setView: (view: string) => void;
  errors?: Record<keyof(ICustomer), string>
  mode: 'edit' | 'new'
  layout: 'wide' | 'narrow'
  bookedbyCustomer: ICustomer
  setErrors: (errors: Record<string, string>) => void
  setBookedbyCustomer: (type: string, value: any) => void;
  toggleBookedBy: (checked: boolean) => void
  isBookedBy: boolean
  country?: string
  bookedByEnabled: boolean
  triggerBookedByValidation?: number
  toggleEmailSmsNotification: (checked: boolean) => void
  disableEmailSmsNotification: boolean
  titleSubscription?: string;
}
export interface IProps extends IBaseProps {

}

export interface IContainerProps extends IBaseProps {

}
